import styled from 'styled-components';

export const StyledLink = styled.div`
  a {
    width: 100%;
    text-align: center;
    margin-top: 3rem;
    font-size: var(--font-size-sm);
    font-weight: var(--font-weight-semibold);
    color: var(--color-black);
    background: var(--color-secondary);
    display: inline-block;
    line-height: 1;
    appearance: none;
    border: none;
    box-shadow: none;
    outline: none;
    cursor: pointer;
    padding: 1.9rem 4rem 1.8rem;
    border-radius: 0;
    padding-right: 3rem;
    padding-left: 3rem;
    border-top-left-radius: var(--border-radius-default);
    border-bottom-right-radius: ${({ half }) => (half ? '0' : 'var(--border-radius-default)')};
    &:hover {
      background: var(--color-black);
      color: var(--color-secondary);
    }
    @media (${({ theme }) => theme.respondTo.tablet}) {
      margin-top: 0;
    }
  }
`;

export const StyledButton = styled.div`
  width: 100%;
  text-align: center;
  margin-top: 3rem;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--color-black);
  background: var(--color-secondary);
  display: inline-block;
  line-height: 1;
  appearance: none;
  border: none;
  box-shadow: none;
  outline: none;
  cursor: pointer;
  padding: 1.9rem 4rem 1.8rem;
  border-radius: 0;
  padding-right: 3rem;
  padding-left: 3rem;
  border-top-left-radius: var(--border-radius-default);
  border-bottom-right-radius: ${({ half }) => (half ? '0' : 'var(--border-radius-default)')};
  &:hover {
    background: var(--color-black);
    color: var(--color-secondary);
  }
  @media (${({ theme }) => theme.respondTo.tablet}) {
    margin-top: 0;
  }
`;
